import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Phone, KeyRound, ArrowLeft, AlertCircle } from 'lucide-react';
import api from '../api/axios';
import './WelcomeLanding.css';

// کاراکتر باربر در صورت نبود لوگو
function BarberIllustration() {
  return (
    <svg viewBox="0 0 100 100" fill="none" style={{ width: '100%', height: '100%' }}>
      <circle cx="28" cy="45" r="7" fill="#ff9e80" />
      <circle cx="72" cy="45" r="7" fill="#ff9e80" />
      <circle cx="50" cy="42" r="22" fill="#ffab91" />
      <path d="M42 20C46 15 54 15 58 20L62 26C62 26 55 24 50 24C45 24 38 26 38 26L42 20Z" fill="#a0522d" />
      <path d="M36 28C40 22 60 22 64 28C64 34 36 34 36 28Z" fill="#8d4004" />
      <path d="M30 45C30 65 42 75 50 75C58 75 70 65 70 45C70 43 30 43 30 45Z" fill="#8d4004" />
      <circle cx="50" cy="48" r="4" fill="#d87d56" />
      <circle cx="43" cy="40" r="2" fill="#212732" />
      <circle cx="57" cy="40" r="2" fill="#212732" />
      <circle cx="45" cy="79" r="3.5" stroke="#ffab91" strokeWidth="2" />
      <circle cx="55" cy="79" r="3.5" stroke="#ffab91" strokeWidth="2" />
      <line x1="47" y1="77" x2="53" y2="71" stroke="#ffab91" strokeWidth="2" />
      <line x1="53" y1="77" x2="47" y2="71" stroke="#ffab91" strokeWidth="2" />
    </svg>
  );
}

export default function WelcomeLanding() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [salon, setSalon] = useState(null);
  const [step, setStep] = useState('phone'); // شروع از مرحله شماره
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // دریافت مشخصات سالن
  useEffect(() => {
    if (slug) {
      api.get(`/salons/${slug}`)
        .then(res => setSalon(res.data.data || res.data))
        .catch(err => console.error('خطا در دریافت اطلاعات سالن:', err));
    }
  }, [slug]);

  // درخواست کد تایید (POST)
  const handleRequestOtp = async (e) => {
    if (e) e.preventDefault();
    if (!phone || phone.trim().length < 10) {
      setError('لطفاً شماره موبایل معتبر وارد کنید.');
      return;
    }

    try {
      setLoading(true);
      setError('');
      
      await api.post('/auth/otp/request', {
        phone: phone.trim(),
        salon_slug: slug,
      });

      setStep('otp');
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'خطا در ارسال کد تایید.');
    } finally {
      setLoading(false);
    }
  };

// بررسی و تایید کد (POST)
const handleVerifyOtp = async (e, customCode = null) => {
  if (e && e.preventDefault) e.preventDefault();

  // اگر کدی مستقیماً پاس داده شده بود از آن استفاده کن، در غیر این صورت از state بخوان
  const codeToVerify = (customCode !== null ? customCode : otp)?.trim();

  // اگر طول کد کمتر از ۵ یا ۶ رقم است اجرا نشود
  if (!codeToVerify || codeToVerify.length < 5) {
    setError('لطفاً کد تایید را به‌صورت کامل وارد کنید.');
    return;
  }

  try {
    setLoading(true);
    setError('');

    const payload = {
      code: codeToVerify,
      phone: phone.trim(),
    };
    if (slug) {
      payload.salon_slug = slug;
    }

    const response = await api.post('/auth/otp/verify', payload);

    const token = response.data?.token || response.data?.data?.token;
    if (token) {
      localStorage.setItem('token', token);
    }

    // هدایت به صفحه مقصد
    if (slug) {
      navigate(`/salons/${slug}/profile`);
    } else {
      navigate('/');
    }
  } catch (err) {
    console.error(err);
    setError(err.response?.data?.message || 'کد وارد شده نامعتبر یا منقضی شده است.');
  } finally {
    setLoading(false);
  }
};


  // ساخت آدرس تصویر لوگو با هندلینگ خطا و فال‌بک
  const logoSrc = salon?.logo_url
    ? (salon.logo_url.startsWith('http') ? salon.logo_url : `http://127.0.0.1:8000/storage/${salon.logo_url}`)
    : (salon?.logo ? `http://127.0.0.1:8000/storage/${salon.logo}` : null);

  return (
    <div className="welcome-container">
      <div className="mobile-card">
        
        {/* بخش لوگو و نام سالن */}
        <div className="brand-section">
          <div className="avatar-wrapper">
            {logoSrc ? (
              <img
                src={logoSrc}
                alt={salon?.name || 'لوگو سالن'}
                className="avatar-img-element"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            ) : (
              <BarberIllustration />
            )}
          </div>

          <h1 className="salon-name">{salon?.name || 'سالن زیبایی و پیرایش'}</h1>
          <p className="brand-subtitle">سامانه نوبت‌دهی آنلاین و هوشمند</p>
        </div>

        {/* فرم احراز هویت */}
        <div className="auth-wrapper">
          {error && (
            <div className="error-msg">
              <AlertCircle size={16} />
              <span>{error}</span>
            </div>
          )}

          {step === 'phone' && (
            <form onSubmit={handleRequestOtp} className="auth-form">
              <div className="input-group">
                <input
                  type="tel"
                  dir="ltr"
                  className="auth-input"
                  placeholder="0912 345 6789"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  autoFocus
                />
              </div>

              <button type="submit" className="auth-btn" disabled={loading}>
                {loading ? (
                  <>
                    <span className="btn-spinner"></span>
                    <span>در حال ارسال...</span>
                  </>
                ) : (
                  <>
                    <Phone size={18} />
                    <span>دریافت کد تایید</span>
                  </>
                )}
              </button>
            </form>
          )}

          {step === 'otp' && (
            <form onSubmit={handleVerifyOtp} className="auth-form">
              <div className="input-group">
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={6} // اگر کدهای OTP شما ۵ رقمی هستند عدد ۵، اگر ۶ رقمی هستند عدد ۶
                  value={otp}
                  placeholder="کد پیامک‌شده"
                  disabled={loading}
                  className='auth-input'
                  onChange={(e) => {
                    // حذف هرگونه کاراکتر غیرعددی (فقط ارقام 0 تا 9)
                    const val = e.target.value.replace(/[^0-9]/g, '');
                    setOtp(val);

                    // به محض تکمیل ۵ رقم، بلافاصله تابع تأیید با مقدار جدید فراخوانی می‌شود
                    if (val.length === 6) {
                      handleVerifyOtp(null, val);
                    }
                  }}
                />

              </div>

              <button type="submit" className="auth-btn" disabled={loading}>
                {loading ? (
                  <>
                    <span className="btn-spinner"></span>
                    <span>در حال بررسی...</span>
                  </>
                ) : (
                  <>
                    <KeyRound size={18} />
                    <span>تایید و ورود</span>
                  </>
                )}
              </button>

              <button
                type="button"
                onClick={() => { setStep('phone'); setError(''); }}
                className="back-btn"
              >
                <ArrowLeft size={15} />
                <span>ویرایش شماره ({phone})</span>
              </button>
            </form>
          )}
        </div>

      </div>
    </div>
  );
}
